import { render, staticRenderFns } from "./estadisticasLeecheros.vue?vue&type=template&id=860c2302&scoped=true&"
import script from "./estadisticasLeecheros.vue?vue&type=script&lang=js&"
export * from "./estadisticasLeecheros.vue?vue&type=script&lang=js&"
import style0 from "./estadisticasLeecheros.vue?vue&type=style&index=0&id=860c2302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860c2302",
  null
  
)

export default component.exports